import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '@/application/i18n/language'
import { investigationSlug } from '@/application/seo/investigation-url'
import type { Investigation } from '@/domains/types'

/** Dense dated list of the most recent investigations, plus a "see all" link. */
export function HomeLatestRiver({ investigations }: { investigations: Investigation[] }) {
  const { t, i18n } = useTranslation()
  const locale = resolveLanguage(i18n.language)
  if (investigations.length === 0) return null

  return (
    <div>
      <h2 className="font-serif text-lg font-bold text-foreground border-b-2 border-border pb-2 mb-3">
        {t('home.latest_title')}
      </h2>
      <ul className="divide-y divide-border">
        {investigations.map((investigation) => (
          <li key={investigation.id} className="py-2 flex items-baseline gap-3">
            <span className="text-xs text-muted-foreground shrink-0 tabular-nums">
              {new Date(investigation.createdAt).toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: 'short',
              })}
            </span>
            <Link
              to="/investigations/$slug"
              params={{ slug: investigationSlug(investigation, locale) }}
              className="text-sm text-foreground hover:underline line-clamp-1"
            >
              {investigation.name}
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-4">
        <Link to="/investigations" className="text-sm text-primary font-semibold hover:underline">
          {t('home.see_all')} →
        </Link>
      </div>
    </div>
  )
}
